import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import iconPairing from 'assets/images/eventBunpimay/pairing.png'
import iconWaterTank from 'assets/images/eventBunpimay/waterTank.png'
import iconWaterGun from 'assets/images/eventBunpimay/gunBody.png'
import { useNavigate } from 'react-router-dom'
import { PATHS } from 'config/routes'
import ModalBunpimayPairingSuccess from 'components/Modal/ModalEvenBunpimay/ModalBunpimayPairingSuccess'
import ModalBunpimayPairingError from 'components/Modal/ModalEvenBunpimay/ModalBunpimayPairingError'
import { useStartPairingEventBunpimay } from 'dataLayer/game'
import { Spinner } from 'react-bootstrap'
import ModalBunpimayPairingSuccessTransition from 'components/Modal/ModalEvenBunpimay/ModalBunpimayPairingSuccessTransition'

function EventBunpimayPairing({ dataBunpimay, refetchApi }) {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const [stateModal, setStateModal] = useState({
		failed: false,
		success: false,
		numberPairing: 0,
		message: '',
	})
	const afterSpinError = error => {
		if (error) {
			let message = error.message
			if (error.errorCode === '272') {
				message = t('event.bunpimay.modal.win.end_event')
			}
			if (error.errorCode === '273') {
				message = t('event.bunpimay.modal.win.pairing_error')
			}
			setStateModal({
				failed: true,
				success: false,
				numberPairing: 0,
				message: message,
			})
		}
	}
	const afterSpinSuccess = data => {
		if (data) {
			setStateModal({
				failed: false,
				success: true,
				numberPairing: data.waterGunPairing,
				message: '',
			})
			refetchApi()
		}
	}
	const { mutate: startPairing, isLoading } = useStartPairingEventBunpimay(
		afterSpinSuccess,
		afterSpinError,
	)
	const handlePairing = () => {
		if (isLoading) return
		startPairing()
	}

	return (
		<div className="container-paring">
			<div className="box-paring">
				<div className="box-paring-item">
					<div className="box-paring-item-info">
						<div className="number-item">
							{dataBunpimay && dataBunpimay.waterTanks
								? dataBunpimay.waterTanks
								: 0}
						</div>
						<img draggable="false" className="icon-item" src={iconWaterTank} />
						<span className="text-item">
							{t('event.bunpimay.pairing.description_water')}
						</span>
					</div>
					<button
						onClick={() => {
							navigate(PATHS.HOME_PAGE)
						}}
						className="btn btn-collect-items"
					>
						{t('event.bunpimay.pairing.play_now')}
					</button>
				</div>
				<button
					className={`button-pairing ${isLoading ? 'disabled' : ''}`}
					onClick={handlePairing}
				>
					<img draggable="false" src={iconPairing} />
					{isLoading ? (
						<div className="button-pairing-loading">
							<Spinner
								animation="border"
								variant="light"
								role="status"
							></Spinner>
						</div>
					) : null}
				</button>
				<div className="box-paring-item">
					<div className="box-paring-item-info">
						<div className="number-item">
							{dataBunpimay && dataBunpimay.gunBodies
								? dataBunpimay.gunBodies
								: 0}
						</div>
						<img draggable="false" className="icon-item" src={iconWaterGun} />
						<span className="text-item">
							{t('event.bunpimay.pairing.description_gun')}
						</span>
					</div>
					<button
						onClick={() => {
							navigate(PATHS.SHOP_PAGE)
						}}
						className="btn btn-collect-items"
					>
						{t('event.bunpimay.pairing.buy_package')}
					</button>
				</div>
			</div>
			<div className="container-paring-description">
				{t('event.bunpimay.pairing.description_gun_water')}
			</div>
			<ModalBunpimayPairingSuccessTransition
				show={stateModal.success}
				numberPairing={stateModal.numberPairing}
				onHide={() =>
					setStateModal({
						failed: false,
						success: false,
						numberPairing: 0,
						message: '',
					})
				}
			/>
			<ModalBunpimayPairingError
				show={stateModal.failed}
				message={stateModal.message}
				onHide={() =>
					setStateModal({
						failed: false,
						success: false,
						numberPairing: 0,
						message: '',
					})
				}
			/>
		</div>
	)
}

export default EventBunpimayPairing
